var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.99805 41.9984H37.9981C40.2072 41.9984 41.9981 40.2076 41.9981 37.9984V9.99841C41.9981 7.78927 40.2072 5.99841 37.9981 5.99841H9.99805C7.78891 5.99841 5.99805 7.78927 5.99805 9.99841V37.9984C5.99805 40.2076 7.78891 41.9984 9.99805 41.9984ZM9.99805 41.9984L31.998 19.9984L41.9981 29.9984M19.998 16.9984C19.998 18.6553 18.6549 19.9984 16.998 19.9984C15.3412 19.9984 13.998 18.6553 13.998 16.9984C13.998 15.3416 15.3412 13.9984 16.998 13.9984C18.6549 13.9984 19.998 15.3416 19.998 16.9984Z",
    stroke: "#85242D",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.ed97ded7fc871821249bae675fed60b1.svg";
export { ForwardRef as ReactComponent };